import styled from "styled-components";

export const StyledUnitTitle = styled.div`
	display: flex;
	justify-items: flex-start;
	align-content: flex-start;
	overflow: hidden;

	h1 {
		margin: 0;
	}

	button {
		width: fit-content;
	}

	& > div {
		display: grid;
		grid-template-columns: 1fr;
		row-gap: 1.2rem;
	}
`;
